export const pluralize = (word, amount) => (amount === 1 ? word : `${word}s`);
